//React
import React from 'react'

//Gatsby
import { Link } from 'gatsby'

export default class Nav extends React.Component {
  render() {
    return (
      <footer class="footer mt-auto">
        <div class="container">
          <div class="row row-copyright d-flex flex-row justify-content-center align-items-center text-center">
            <span>&copy; 2024 PicoNext, Inc.</span>
            <a
              href={`${process.env.MARKETING_DOMAIN}about/terms/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms
            </a>
            <a
              href={`${process.env.MARKETING_DOMAIN}about/privacy/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy
            </a>
          </div>
        </div>
      </footer>
    )
  }
}
